import { useState } from 'react'
import { Container, Eyebrow } from './primitives'

const ITEMS = [
  {
    q: 'Can you migrate me from Squarespace or Framer?',
    a: 'Yes. Vello rebuilds on a modern stack and points your domain when it ships. You keep the old URL, the old pages get redirected, your SEO survives. A Framer file, if you have one, is reference only. The new site is designed from scratch.',
  },
  {
    q: 'Do you write the copy?',
    a: 'Yes, if you want. The intake asks for a few bullet points per page: positioning, past clients, how you work. Copy gets drafted from that. You review once, it ships. If you already have copy you love, it stays.',
  },
  {
    q: 'What if I bring on a partner later?',
    a: 'Vello+ covers adding team members, new bio pages, case studies, updated pricing, all of it. One request at a time, 48 hours each. If you outgrow the retainer and want a full redesign, same flat-price model applies.',
  },
  {
    q: 'Do you connect to HubSpot, Pipedrive, or Attio?',
    a: 'Yes, any of those, plus Close, Folk, or a plain webhook to your email. The contact form, any lead magnet, and the intake form all pipe to your CRM of choice.',
  },
  {
    q: 'What if I do not like the first draft?',
    a: 'One revision pass is included in Launch. If the first draft misses, tell me why in writing and a redesign follows. If round two still does not land, your Launch fee is refunded in full.',
  },
  {
    q: 'Is the site mine to keep?',
    a: 'Completely. You own the code, the design files, the domain, the CRM data. Cancel Vello+ and the repository hands off to your developer, or stays hosted under your account.',
  },
  {
    q: 'Can I see the site before I pay?',
    a: 'No, but the work and example layouts above give you a sense of the range, and the Launch price is flat. Cancel within 48 hours of paying, before work starts, for a full refund, no questions.',
  },
  {
    q: 'How many clients do you take per month?',
    a: 'Four. More than that and the seven-day turnaround breaks. If the month is full, you go on the list. Usually under two weeks.',
  },
]

export function FAQ() {
  const [open, setOpen] = useState(0)

  return (
    <section
      id="faq"
      style={{ padding: '96px 0', borderTop: '1px solid var(--line)' }}
    >
      <Container>
        <div
          className="faq-grid"
          style={{ display: 'grid', gridTemplateColumns: '360px 1fr', gap: 80 }}
        >
          <div>
            <Eyebrow>FAQ</Eyebrow>
            <h2
              style={{
                fontSize: 'clamp(28px, 3vw, 42px)',
                lineHeight: 1.1,
                letterSpacing: '-0.025em',
                fontWeight: 400,
                margin: '20px 0 0',
                fontFamily: 'var(--serif)',
              }}
            >
              Questions that come up before starting.
            </h2>
            <p
              style={{
                fontSize: 15,
                color: 'var(--muted)',
                lineHeight: 1.55,
                marginTop: 20,
              }}
            >
              Can&apos;t find yours?{' '}
              <a
                href="mailto:hello@withvello.com"
                style={{ borderBottom: '1px solid var(--line-strong)' }}
              >
                hello@withvello.com
              </a>
            </p>
          </div>
          <div>
            {ITEMS.map((it, i) => {
              const isOpen = open === i
              return (
                <div
                  key={it.q}
                  style={{
                    borderTop: i === 0 ? '1px solid var(--line-strong)' : 'none',
                    borderBottom: '1px solid var(--line-strong)',
                  }}
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    style={{
                      width: '100%',
                      textAlign: 'left',
                      background: 'transparent',
                      border: 'none',
                      padding: '22px 0',
                      cursor: 'pointer',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      gap: 16,
                      fontSize: 17,
                      fontWeight: 500,
                      letterSpacing: '-0.01em',
                      color: 'var(--fg)',
                    }}
                  >
                    <span>{it.q}</span>
                    <span
                      style={{
                        fontFamily: 'var(--mono)',
                        fontSize: 14,
                        color: 'var(--muted)',
                        transform: isOpen ? 'rotate(45deg)' : 'rotate(0)',
                        transition: 'transform 200ms ease',
                        flexShrink: 0,
                      }}
                    >
                      +
                    </span>
                  </button>
                  <div
                    style={{
                      maxHeight: isOpen ? 400 : 0,
                      overflow: 'hidden',
                      transition: 'max-height 300ms ease',
                    }}
                  >
                    <div
                      style={{
                        paddingBottom: 24,
                        fontSize: 15.5,
                        lineHeight: 1.6,
                        color: 'var(--muted)',
                        maxWidth: 640,
                      }}
                    >
                      {it.a}
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </Container>
    </section>
  )
}
